<template>
  <div class="flex space-x-2">
    <div class="grow">
      <input
        type="text"
        :value="props.link"
        class="w-full rounded-lg border border-neutral-500 p-2 text-sm outline-0"
        readonly
      />
    </div>
    <TButtonInlineSecondary @click="copyToClipboard">
      <div class="flex items-center space-x-2">
        <TIcon name="copy" class="h-4 w-4" /><span>{{
          $t('generic.copy_link')
        }}</span>
      </div>
    </TButtonInlineSecondary>
  </div>
</template>
<script setup lang="ts">
import clipboard from 'clipboardy';
import toast from '~/components/Toast';

const { $t } = useNuxtApp();

const props = defineProps<{
  link: string;
}>();

function copyToClipboard() {
  clipboard.write(props.link);
  toast.success({
    header: $t('link.copied.title'),
    description: $t('link.copied.description'),
  });
}
</script>
